import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import SpecOutDto from '@/models/SpecOuts/SpecOutDto';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import FilterSpecOutSearchViewModel from '@/models/SpecOuts/FilterSpecOutSearchViewModel';
import CurrentSpecOutSearchCriteria from '@/models/SpecOuts/CurrentSpecOutSearchCriteria';
import SearchSpecOutsRequest from '@/models/SpecOuts/SearchSpecOutsRequest';
import CreateSpecOutRequest from '@/models/SpecOuts/CreateSpecOutRequest';

export interface ISpecOutListState {
  loading: boolean;
  specOuts: SpecOutDto[];
  filterSpecOutSearchViewModel: FilterSpecOutSearchViewModel;
  currentSpecOutSearchCriteria: CurrentSpecOutSearchCriteria;
  newSpecOutId: string;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'SpecOutList', namespaced: true})
class SpecOutList extends VuexModule implements ISpecOutListState {

  public loading = false;
  public specOuts: SpecOutDto[] = [];
  public filterSpecOutSearchViewModel: FilterSpecOutSearchViewModel = new FilterSpecOutSearchViewModel();
  public currentSpecOutSearchCriteria: CurrentSpecOutSearchCriteria = new CurrentSpecOutSearchCriteria();
  public newSpecOutId = '';
  public loadingDialog = false;

  @Action
  async searchSpecOuts() {
    const request = new SearchSpecOutsRequest();

    if (this.filterSpecOutSearchViewModel.selectedOwner != null) {
      request.ownerId = this.filterSpecOutSearchViewModel.selectedOwner.id;
    }

    if (this.filterSpecOutSearchViewModel.selectedBranch != null) {
      request.branchId = this.filterSpecOutSearchViewModel.selectedBranch.id;
    }

    request.status = this.filterSpecOutSearchViewModel.selectedStatus;

    this.setLoading(true);
    await ajax.post(`/api/v1/agency/spec-outs/search`, request)
    .then(response => {
      this.context.commit("setSpecOuts", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  public async createSpecOut(request: CreateSpecOutRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/spec-outs`, request)
    .then(response => {
      this.context.commit("setSpecOutIdFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.specOuts = [];
    this.newSpecOutId = '';
    this.filterSpecOutSearchViewModel = new FilterSpecOutSearchViewModel();
    this.currentSpecOutSearchCriteria = new CurrentSpecOutSearchCriteria();
    this.loading = false;
    this.loadingDialog = false;
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }

  @Mutation
  private async setSpecOuts(specOuts: SpecOutDto[]) {
    this.currentSpecOutSearchCriteria = new CurrentSpecOutSearchCriteria();
    this.currentSpecOutSearchCriteria.selectedBranch = this.filterSpecOutSearchViewModel.selectedBranch;
    this.currentSpecOutSearchCriteria.selectedOwner = this.filterSpecOutSearchViewModel.selectedOwner;
    this.currentSpecOutSearchCriteria.selectedStatus = this.filterSpecOutSearchViewModel.selectedStatus;
    this.specOuts = specOuts;
  }

  @Mutation
  private async setSpecOutIdFromCreate(specOut: SpecOutDto) {
    this.newSpecOutId = specOut.id;
  }
}

export const SpecOutListModule = getModule(SpecOutList)
